<template>
  <!--begin::Quotation Listing-->
  <div class="quotation-template">
    <PageHeaderCount
      moduleType="quotation"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_quotations"
      countkey="quotation_status_count"
    ></PageHeaderCount>
    <ListingTemplate
      :customClass="'quotation-listing'"
      v-if="getPermission('quotation:view')"
    >
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-flex class="pt-0 my-auto">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-flex>
              <v-flex class="pt-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('quotation:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    transition="slide-y-transition"
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(more, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="updateBulkAction(more.action)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              more.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ more.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-flex>
            </template>
            <template v-else>
              <v-flex class="pt-0 mxw-200">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :disabled="dataLoading"
                    :items="statusList"
                    v-model="status"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <template v-if="item.value == 'submit_for_approval'">
                          <template v-if="userDetails.role == 4">
                            <v-list-item-title
                              v-text="'Submied For Approval'"
                            ></v-list-item-title>
                          </template>
                          <template v-else>
                            <v-list-item-title
                              v-text="'Pending For Approval'"
                            ></v-list-item-title>
                          </template>
                        </template>
                        <template v-else>
                          <v-list-item-title
                            v-text="item.text"
                          ></v-list-item-title>
                        </template>
                        <template v-if="item.value == 'submit_for_approval'">
                          <template v-if="userDetails.role == 4">
                            <v-list-item-subtitle
                              v-text="'Submied For Approval'"
                            ></v-list-item-subtitle>
                          </template>
                          <template v-else>
                            <v-list-item-subtitle
                              v-text="'Pending For Approval'"
                            ></v-list-item-subtitle>
                          </template>
                        </template>
                        <!--   <template v-else>
                          <v-list-item-subtitle
                            v-text="item.description"
                          ></v-list-item-subtitle>
                        </template> -->
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_quotations
                          }}</template>
                          <template v-else>{{
                            item.quotation_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-flex>
              <v-flex
                class="pt-0 pr-0 justify-flex-end d-flex quotation-listing-button-right"
              >
                <template v-if="getPermission('quotation:create')">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    :to="getDefaultRoute('quotation.create')"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="openFilterDialog()"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>
                <v-menu
                  max-height="400"
                  max-width="260"
                  offset-y
                  left
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          v-on:change="updateVisible()"
                          hide-details
                          class="pt-2 mt-0"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <v-menu offset-y left v-if="false">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip top content-class="custom-top-tooltip">
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                          depressed
                          :disabled="dataLoading"
                          class="ml-2 custom-bold-button"
                          color="cyan white--text"
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }"
                        >
                          {{ entityObject.name }}
                        </v-btn>
                      </template>
                      <span>Entity</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in entityList"
                      :key="index"
                      link
                      v-on:click="updateEntity(item)"
                    >
                      <v-list-item-title class="font-weight-600">{{
                        item.name
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <PageTips v-if="false" module="quotation"></PageTips>
              </v-flex>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Quotation"
          :basicSearchFields="[
            'barcode',
            'reference',
            'title',
            'sales_id',
            'prepared_by',
            'company_name',
            'customer',
            'property',
            'billing',
            'line_items',
          ]"
          :allowedSearchFields="searchableArray"
          :searchEnabled="searchEnabled"
          :result="totalRows"
          @clear-customer-filters="clearCustomerFilters"
        >
        </ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{ 'checkbox-width-limit': cols.checkbox }"
                      :style="{ 'max-width': cols.width }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="rowData.length > 0">
                  <tr
                    v-for="(data, index) in rowData"
                    :key="index"
                    link
                    class="quotation-listing-row"
                  >
                    <template v-for="cols in customThead">
                      <td
                        v-if="cols.visible"
                        :key="cols.id"
                        :class="{
                          'simple-table-td': !cols.checkbox,
                          'checkbox-width-limit': cols.checkbox,
                        }"
                        :style="{ 'max-width': cols.width }"
                        v-on:click="
                          Number(cols.checkbox) == 0
                            ? rowClicked(data)
                            : 'javascript:void(0)'
                        "
                      >
                        <template
                          v-if="cols.checkbox && Number(cols.checkbox) == 1"
                        >
                          <v-checkbox
                            dense
                            v-model="selectedRows"
                            v-bind:value="data.id"
                            color="cyan"
                            class="hide-margin"
                            hide-details
                          ></v-checkbox>
                        </template>
                        <template v-else-if="cols.field == 'barcode'">
                          <div class="d-inline-block">
                            <Barcode
                              route="quotation.detail"
                              :barcode="data.barcode"
                              :id="data.id"
                            ></Barcode>
                            <v-chip
                              label
                              color="red"
                              class="text-white p-3 mb-1"
                              v-if="data.q_duplicate_barcode"
                              outlined
                              small
                              >{{ data.q_duplicate_barcode }}</v-chip
                            >
                            <v-chip
                              label
                              color="red"
                              class="text-white p-3 mb-1"
                              v-if="data.enquiry_barcode"
                              outlined
                              small
                              >{{ data.enquiry_barcode }}</v-chip
                            >
                            <v-chip
                              label
                              color="red"
                              class="text-white p-3 mb-1"
                              v-if="data.q_requote_barcode"
                              outlined
                              small
                              >{{ data.q_requote_barcode }}</v-chip
                            >
                            <v-chip
                              label
                              color="red"
                              class="text-white p-3 mb-1"
                              v-if="data.opportunity_barcode"
                              outlined
                              small
                              >{{ data.opportunity_barcode }}</v-chip
                            >
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'date'">
                          <p
                            class="m-0 custom-nowrap-ellipsis"
                            v-if="data.added_at"
                          >
                            <b>Created: </b> {{ formatDate(data.date) }}
                          </p>
                          <p
                            class="m-0 custom-nowrap-ellipsis"
                            v-if="data.validity_till && data.validity_till > 0"
                          >
                            <b>Validity: </b> {{ getValidityDate(data) }}({{
                              data.validity_till
                            }}Days)
                          </p>
                          <p
                            class="m-0 custom-nowrap-ellipsis"
                            v-if="data.sent_date"
                          >
                            <b>Sent: </b> {{ formatDate(data.sent_date) }}
                          </p>
                        </template>
                        <template v-else-if="cols.field == 'job_title'">
                          <div
                            class="property-listing-customer"
                            style="width: 300px"
                          >
                            <v-tooltip
                              top
                              max-width="400"
                              content-class="custom-top-tooltip"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <p
                                  class="m-0 text-capitalize custom-nowrap-ellipsis"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  {{ data?.job_title || "-" }}
                                </p>
                              </template>

                              <span>{{ data?.job_title || "-" }}</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'count'">
                          <div class="d-flex flex-column gap-1">
                            <v-chip
                              small
                              color="green lighten-5"
                              text-color="green darken-3"
                              class="font-weight-600 px-2 py-3 mb-1"
                            >
                              <v-avatar
                                left
                                class="green darken-1 white--text font-weight-600 font-size-10 mr-1"
                                style="width: 15px; height: 15px"
                              >
                                {{ data.visit_multiple_count }}
                              </v-avatar>
                              Visit
                            </v-chip>
                            <v-chip
                              small
                              color="red lighten-5"
                              text-color="red darken-3"
                              class="font-weight-600 px-2 py-3 mb-1"
                            >
                              <v-avatar
                                left
                                class="red darken-1 white--text font-weight-600 font-size-10 mr-1"
                                style="width: 15px; height: 15px"
                              >
                                {{ data.invoice_count }}
                              </v-avatar>
                              Invoice
                            </v-chip>
                          </div>
                          <div class="quotation-listing-customer" v-if="false">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Visit Count: </b>
                              <template
                                v-if="data && data.visit_multiple_count > 0"
                              >
                                <span
                                  class="count-radius"
                                  style="
                                    background-color: green !important;
                                    color: white;
                                    margin-left: 19px;
                                  "
                                  >{{ data.visit_multiple_count }}</span
                                >
                              </template>
                              <span
                                v-else
                                style="
                                  background-color: #93959f !important;
                                  color: white;
                                  margin-left: 19px !important;
                                "
                                class="ml-1 count-radius white-text"
                                >0</span
                              >
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Invoice Count: </b>
                              <template v-if="data && data.invoice_count > 0">
                                <span
                                  style="
                                    background-color: red !important;
                                    color: white;
                                  "
                                  class="ml-1 count-radius bg-light-success"
                                  >{{ data.invoice_count }}</span
                                >
                              </template>
                              <span
                                v-else
                                style="
                                  background-color: #93959f !important;
                                  color: white;
                                "
                                class="ml-1 count-radius white-text"
                                >0</span
                              >
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'reference'">
                          <div class="quotation-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <template v-if="data.reference">{{
                                data.reference
                              }}</template>
                              <template v-else
                                ><em class="text--secondary"
                                  >No Reference</em
                                ></template
                              >
                            </p>
                          </div>
                        </template>
                        <template
                          v-else-if="cols.field == 'quotation_category'"
                        >
                          <div class="quotation-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <template v-if="data.quotation_category">{{
                                data.quotation_category
                              }}</template>
                              <template v-else
                                ><em class="text--secondary"
                                  >No Quotation Category</em
                                ></template
                              >
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'basic_detail'">
                          <div class="quotation-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>PIC: </b>
                              <template v-if="data.sales_user">
                                <v-chip
                                  v-if="
                                    data &&
                                    data.sales_user &&
                                    data.sales_user.display_name
                                  "
                                  small
                                  class="mb-1 mr-1"
                                >
                                  <v-avatar left small>
                                    <img
                                      v-if="
                                        data.sales_user &&
                                        data.sales_user.profile_logo &&
                                        data.sales_user.profile_logo.file
                                      "
                                      :src="
                                        data.sales_user.profile_logo.file.url
                                      "
                                    />
                                    <img
                                      v-else
                                      src="https://ams-dev.businessthrust.com//media/misc/no_photo_found.png"
                                    />
                                  </v-avatar>
                                  <span>{{
                                    data.sales_user.display_name
                                  }}</span>
                                </v-chip>
                              </template>
                              <template v-else
                                ><em class="text--secondary"
                                  >No PIC</em
                                ></template
                              >
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Prepared by: </b>
                              <template
                                v-if="
                                  data.prepared_user &&
                                  data.prepared_user.display_name
                                "
                                >{{ data.prepared_by }}
                                <v-chip
                                  v-if="
                                    data &&
                                    data.prepared_user &&
                                    data.prepared_user.display_name
                                  "
                                  small
                                  class="mb-1 mr-1"
                                >
                                  <v-avatar left small>
                                    <img
                                      v-if="
                                        data.prepared_user &&
                                        data.prepared_user.profile_logo &&
                                        data.prepared_user.profile_logo.file
                                      "
                                      :src="
                                        data.prepared_user.profile_logo.file.url
                                      "
                                    />
                                    <img
                                      v-else
                                      src="https://ams-dev.businessthrust.com//media/misc/no_photo_found.png"
                                    />
                                  </v-avatar>
                                  <span>{{
                                    data.prepared_user.display_name
                                  }}</span>
                                </v-chip>
                              </template>
                              <template v-else
                                ><em class="text--secondary"
                                  >No Prepared by</em
                                ></template
                              >
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'rating'">
                          <div class="quotation-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis d-flex">
                              <template v-if="data.rating"
                                ><v-rating
                                  readonly
                                  dense
                                  v-model.trim="data.rating"
                                  background-color="orange lighten-3"
                                  color="orange"
                                ></v-rating
                              ></template>
                              <template v-else
                                ><em class="text--secondary"
                                  >No Rating</em
                                ></template
                              >
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'status'">
                          <div class="quotation-listing-status">
                            <v-chip
                              label
                              small
                              :color="data?.qt_status_color"
                              :text-color="data?.qt_status_textcolor"
                              class="ml-2 text-uppercase font-weight-600 pt-1"
                            >
                              {{ data?.qt_status_text }}
                            </v-chip>
                            <div class="mb-1">
                              <template
                                v-if="
                                  data.pending_for_approver == 1 &&
                                  data.status == 1
                                "
                              >
                                <v-chip
                                  color="red"
                                  text-color="white"
                                  label
                                  small
                                  class="p-3 ml-2 mb-1"
                                >
                                  {{ data.pending_approver }}
                                </v-chip>
                              </template>
                            </div>
                            <div class="mb-1">
                              <v-chip
                                v-if="
                                  data &&
                                  data.quotation_duplicate &&
                                  data.quotation_duplicate > 0
                                "
                                label
                                small
                                color="red"
                                outlined
                                class="text-white p-3 ml-2 mb-1"
                                >Duplicate</v-chip
                              >
                              <v-chip
                                v-if="
                                  data &&
                                  data.quotation_requote &&
                                  data.quotation_requote > 0
                                "
                                label
                                small
                                color="red"
                                outlined
                                class="text-white p-3 ml-2"
                                >Re-Quote</v-chip
                              >
                              <div class="mb-1">
                                <template v-if="data.is_revised">
                                  <v-tooltip
                                    top
                                    content-class="custom-top-tooltip"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip
                                        v-bind="attrs"
                                        v-on="on"
                                        label
                                        color="red"
                                        outlined
                                        small
                                        class="text-white p-3 ml-2"
                                      >
                                        REVISED
                                      </v-chip>
                                    </template>
                                    <span>Quotation is Revised</span>
                                  </v-tooltip>
                                </template>
                              </div>
                              <div class="mb-1">
                                <template
                                  v-if="
                                    data &&
                                    data.quotation_revise &&
                                    data.quotation_revise > 0 &&
                                    !data.is_revised
                                  "
                                >
                                  <v-tooltip
                                    top
                                    content-class="custom-top-tooltip"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip
                                        v-bind="attrs"
                                        v-on="on"
                                        label
                                        color="teal"
                                        outlined
                                        small
                                        class="text-white p-3 ml-2"
                                      >
                                        REVISION
                                      </v-chip>
                                    </template>
                                    <span
                                      >Revision of
                                      {{ data.q_revise_barcode }}</span
                                    >
                                  </v-tooltip>
                                </template>
                              </div>
                            </div>
                            <div
                              class="mb-1"
                              v-if="
                                data?.invoice_count &&
                                data?.invoice_count > 0 &&
                                data.status == 2
                              "
                            >
                              <v-chip
                                color="orange"
                                text-color="white"
                                label
                                small
                                class="ml-2 mb-1 font-weight-600"
                              >
                                Invoiced
                              </v-chip>
                            </div>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'display_name'">
                          <div class="quotation-listing-customer">
                            <p
                              class="m-0 custom-nowrap-ellipsis line-climp-content"
                            >
                              {{
                                data &&
                                data.customer &&
                                data.customer.display_name
                              }}
                            </p>

                            <template
                              v-if="
                                false && data.customer.contact_person_count > 1
                              "
                            >
                              <v-chip
                                small
                                color="blue white--text"
                                label
                                class="ml-2"
                                v-on:click.prevent.stop="
                                  customerRedirect(data.customer.id)
                                "
                              >
                                <span class="font-size-16 font-weight-500">
                                  +{{
                                    data.customer.contact_person_count - 1
                                  }}
                                  More</span
                                >
                              </v-chip>
                            </template>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'company_name'">
                          <div class="quotation-listing-customer">
                            <p
                              class="m-0 custom-nowrap-ellipsis line-climp-content"
                            >
                              <b
                                ><v-icon small class="me-1"
                                  >mdi-domain</v-icon
                                ></b
                              >
                              <template
                                v-if="
                                  data &&
                                  data.customer &&
                                  data.customer.company_name
                                "
                              >
                                {{ data.customer.company_name }}
                              </template>
                              <em class="text-muted" v-else> no company</em>
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'company_info'">
                          <div class="quotation-listing-customer">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>
                                <v-icon small class="me-1">mdi-email</v-icon></b
                              >
                              <template
                                v-if="
                                  data.billing_person &&
                                  data.billing_person.primary_email
                                "
                              >
                                {{ data.billing_person.primary_email }}
                              </template>
                              <em class="text-muted" v-else> no email</em>
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b
                                ><v-icon small class="me-1"
                                  >mdi-phone</v-icon
                                ></b
                              >
                              <template
                                v-if="
                                  data.billing_person &&
                                  data.billing_person.primary_phone
                                "
                              >
                                {{ data.billing_person.primary_phone }}
                              </template>
                              <em class="text-muted" v-else>
                                no phone number</em
                              >
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'sub_total'">
                          <div class="quotation-listing-amount">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Sub Total: </b>
                              <span class="font-weight-700">
                                {{
                                  $accountingJS.formatMoney(data.sub_total)
                                }}</span
                              >
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Tax: </b>
                              {{ $accountingJS.formatMoney(data.tax_amount) }}
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'discount'">
                          <div class="quotation-listing-amount">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Discount: </b>
                              <!--     {{
                                $accountingJS.formatMoney(data.discount_amount)
                              }} -->
                              <span v-if="data.discount_value_type == 2"
                                >({{ formatNumber(data.discount_value) }}%)
                              </span>
                              <span v-else>
                                {{
                                  $accountingJS.formatMoney(
                                    data.discount_amount
                                  )
                                }}</span
                              >
                            </p>
                            <p class="m-0 custom-nowrap-ellipsis">
                              <b>Adjustment: </b>
                              {{ $accountingJS.formatMoney(data.adjustment) }}
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'total'">
                          <div class="quotation-listing-amount">
                            <p class="m-0 custom-nowrap-ellipsis">
                              <span class="font-weight-700">
                                {{
                                  $accountingJS.formatMoney(data.total)
                                }}</span
                              >
                            </p>
                          </div>
                        </template>
                        <template v-else-if="cols.field == 'added_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.added_by)"
                            :data="data"
                          >
                            <template v-slot:first_letters>
                              {{ getFirstLetters(data.added_by?.display_name) }}
                            </template>
                            <template v-slot:display_name>
                              {{ data.added_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              <template v-if="getDateCountAll(data.added_at)">{{
                                data.created_at
                              }}</template>
                              <template v-else>{{
                                formatDateTime(data.added_at)
                              }}</template>
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDate(data.added_at) }}
                              {{ formatTime(data.added_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else-if="cols.field == 'updated_at'">
                          <TableActivity
                            v-if="!lodash.isEmpty(data.updated_by)"
                            :data="data"
                          >
                            <template v-slot:first_letters>
                              {{
                                getFirstLetters(data.updated_by?.display_name)
                              }}
                            </template>
                            <template v-slot:display_name>
                              {{ data.updated_by.display_name }}
                            </template>
                            <template v-slot:date_time>
                              {{ data.modified_at }}
                            </template>
                            <template v-slot:format_date_time>
                              {{ formatDateTime(data.updated_at) }}
                            </template>
                          </TableActivity>
                        </template>
                        <template v-else>
                          <div v-html="printRowData(cols, data)"></div>
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
                <tr v-else-if="!dataLoading">
                  <td colspan="15" class="py-4">
                    <p
                      class="m-0 row-not-found text-center font-weight-500 font-size-16"
                    >
                      <img
                        :src="$assetURL('media/error/empty.png')"
                        class="row-not-found-image"
                      />
                      Uhh... There are no quotation at the moment.
                    </p>
                  </td>
                </tr>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <v-navigation-drawer
          v-model="searchDialog"
          app
          bottom
          temporary
          stateless
          right
          :width="600"
          style="z-index: 500"
        >
          <v-card
            text
            elevation="0"
            class="d-flex flex-column h-100 custom-field"
          >
            <v-card-title
              class="headline dialog-custom-header text-uppercase custom-border-bottom custom-header-blue-text white-background"
            >
              <span style="font-size: 18px"> Filter Quotation </span>
              <v-spacer></v-spacer>
              <v-btn icon small @click="searchDialog = false">
                <v-icon size="30">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="flex-grow-1 px-3">
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll custom-box-top-inner-shado"
                style="height: calc(100vh - 145px); position: relative"
              >
                <v-container fluid class="pt-0 custom-search-filter">
                  <v-row>
                    <v-col md="12">
                      <v-menu
                        v-if="false"
                        v-model="datePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            dense
                            filled
                            flat
                            label="Dates Range"
                            hide-details
                            solo
                            clearable
                            v-on:click:clear="dates = []"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :value="formattedDate"
                            color="cyan"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="cyan"
                          range
                          v-model="dates"
                        ></v-date-picker>
                      </v-menu>
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Data Range</label
                      >
                      <DateRangePicker
                        placeholder="Data Range"
                        v-model="dates"
                        v-on:click:clear="clearFilter('dates')"
                        class="mr-2"
                      ></DateRangePicker>
                    </v-col>

                    <template v-for="(field, index) in searchableArray">
                      <v-col
                        md="12"
                        :key="index"
                        v-if="field != 'dates'"
                        :style="{
                          display:
                            field == 'customer' ||
                            field == 'property' ||
                            field == 'billing'
                              ? 'none'
                              : 'block',
                        }"
                      >
                        <label
                          class="v-label font-weight-500 font-size-13 text-capitalize"
                        >
                          {{
                            field == "sales_id"
                              ? "PIC"
                              : getFilterLabel(field, "Quotation")
                          }}
                        </label>
                        <Datepicker
                          v-if="field == 'open_till'"
                          solo
                          flat
                          clearable
                          v-model.trim="listingSearch[field]"
                          placeholder="Open Still"
                        ></Datepicker>
                        <v-autocomplete
                          v-else-if="field == 'sales_id'"
                          dense
                          color="cyan"
                          filled
                          id="sales-representatives"
                          :items="userList"
                          :disabled="dataLoading"
                          :loading="dataLoading"
                          v-model.trim="listingSearch[field]"
                          placeholder="PIC"
                          solo
                          flat
                          clearable
                          item-color="cyan"
                          item-text="display_name"
                          item-value="display_name"
                          hide-details
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-html="'No PIC Found.'"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                          v-else-if="field == 'quotation_category'"
                          dense
                          color="cyan"
                          filled
                          id="quotation-category"
                          :items="quotationCategoryList"
                          :disabled="dataLoading"
                          :loading="dataLoading"
                          v-model.trim="listingSearch[field]"
                          placeholder="Quotation Category"
                          solo
                          flat
                          clearable
                          item-color="cyan"
                          item-text="text"
                          item-value="text"
                          hide-details
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-html="'No Quotation Category Found.'"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                        <v-text-field
                          v-else
                          :style="{
                            display:
                              field == 'customer' ||
                              field == 'property' ||
                              field == 'billing'
                                ? 'none'
                                : 'block',
                          }"
                          v-model.trim="listingSearch[field]"
                          dense
                          filled
                          hide-details
                          :placeholder="
                            field == 'customer_detail[value]'
                              ? 'Customer Details[Phone Number]'
                              : getFilterLabel(field, 'Quotation')
                          "
                          solo
                          flat
                          clearable
                          @keydown.enter="filterRows"
                          color="cyan"
                        ></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                  <CustomerListingFilter
                    :key="`customer-listing-filter`"
                    :customer_list="customer_list"
                    @update-listing-search="updateListingSearch"
                    :listingSearch="listingSearch"
                    :clearFilters="clearCustomerFiltersFlag"
                  />
                </v-container>
              </perfect-scrollbar>
            </v-card-text>
            <v-divider class="my-0"></v-divider>
            <v-card-actions class="d-flex justify-en px-4 pb-4">
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red white--text"
                v-on:click="removeFilters('clear')"
              >
                <v-icon left>mdi-close</v-icon>
                <span>Clear Filter</span>
              </v-btn>
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                v-on:click="filterRows"
              >
                <v-icon left>mdi-magnify</v-icon>
                <span>Apply Filter</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
        <Dialog :commonDialog="searchDialog" v-if="false">
          <template v-slot:title>Filter Quotation </template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="6">
                    <v-menu
                      v-if="false"
                      v-model="datePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Dates Range"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="dates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="formattedDate"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="dates"
                      ></v-date-picker>
                    </v-menu>

                    <DateRangePicker
                      label="Data Range"
                      v-model="dates"
                      v-on:click:clear="clearFilter('dates')"
                      class="mr-2"
                    ></DateRangePicker>
                  </v-col>

                  <template v-for="(field, index) in searchableArray">
                    <v-col
                      md="6"
                      :key="index"
                      v-if="field != 'dates'"
                      :style="{
                        display:
                          field == 'customer' ||
                          field == 'property' ||
                          field == 'billing'
                            ? 'none'
                            : 'block',
                      }"
                    >
                      <Datepicker
                        v-if="field == 'open_till'"
                        solo
                        flat
                        clearable
                        v-model.trim="listingSearch[field]"
                        label="Open Still"
                      ></Datepicker>
                      <v-autocomplete
                        v-else-if="field == 'sales_id'"
                        dense
                        color="cyan"
                        filled
                        id="sales-representatives"
                        :items="userList"
                        :disabled="dataLoading"
                        :loading="dataLoading"
                        v-model.trim="listingSearch[field]"
                        label="Sales representatives"
                        solo
                        flat
                        clearable
                        item-color="cyan"
                        item-text="display_name"
                        item-value="user_email"
                        hide-details
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="'No PIC Found.'"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        v-else
                        :style="{
                          display:
                            field == 'customer' ||
                            field == 'property' ||
                            field == 'billing'
                              ? 'none'
                              : 'block',
                        }"
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :label="
                          field == 'customer_detail[value]'
                            ? 'Customer Details[Phone Number]'
                            : getFilterLabel(field, 'Quotation')
                        "
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
                <CustomerListingFilter
                  :key="`customer-listing-filter`"
                  :customer_list="customer_list"
                  @update-listing-search="updateListingSearch"
                  :listingSearch="listingSearch"
                  :clearFilters="clearCustomerFiltersFlag"
                />
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              depressed
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
        <ImportTemplate
          :dialog="importDialog"
          sample-url="quotation/import-sample"
          api-url="quotation/import"
          title="Import Quotation"
          v-on:close="importDialog = false"
        ></ImportTemplate>

        <template v-if="entityDialog">
          <EntityDialog
            :entity-dialog="entityDialog"
            v-on:closeDialog="closeDialog"
            v-on:resetAll="resetAll"
            v-on:selectEntity="selectEntity"
          ></EntityDialog>
        </template>
        <template v-if="entity && customerDialog">
          <CustomerDialog
            :entity="entity"
            :customerDialog="customerDialog"
            v-on:closeDialog="closeDialog"
            v-on:resetAll="resetAll"
            v-on:selectCustomer="selectCustomer"
          ></CustomerDialog>
        </template>
        <template v-if="customerPersonDialog">
          <CustomerPersonDialog
            disabled-auto-select
            :customerPersonDialog="customerPersonDialog"
            :customer="customer"
            v-on:closeDialog="closeDialog"
            v-on:resetAll="resetAll"
            v-on:selectCustomerPerson="selectCustomerPerson"
          >
          </CustomerPersonDialog>
        </template>
        <template v-if="customerPropertyDialog">
          <CustomerPropertyDialog
            disabled-auto-select
            :customerPropertyDialog="customerPropertyDialog"
            :customer="customer"
            v-on:closeDialog="closeDialog"
            v-on:resetAll="resetAll"
            v-on:selectCustomerProperty="selectCustomerProperty"
          ></CustomerPropertyDialog>
        </template>
      </template>
    </ListingTemplate>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import QuotationMixin from "@/core/lib/quotation/quotation.mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET,
  PATCH,
  QUERY,
  DOWNLOAD,
} from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";
import CustomerListingFilter from "@/view/pages/partials/Customer-Listing-Filter.vue";

import { saveAs } from "file-saver";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import EntityDialog from "@/view/pages/partials/Select-Entity.vue";
import CustomerPropertyDialog from "@/view/pages/partials/Select-Customer-Property.vue";
import JwtService from "@/core/services/jwt.service";
import Datepicker from "@/view/pages/partials/Datepicker.vue";
import ImportTemplate from "@/view/pages/partials/Import-Template.vue";
import DateRangePicker from "@/view/components/DateRangePicker";
import { SearchEventBus } from "@/core/lib/search.lib";
import ObjectPath from "object-path";
import moment from "moment-timezone";
export default {
  mixins: [CommonMixin, ListingMixin, QuotationMixin],
  name: "quotation-list",
  data() {
    return {
      userDetails: {},
      exportLoading: false,
      dates: [],
      customer_list: [],
      customer_loading: false,
      userList: [],
      pageModule: "quotation-listing",
      routeAPI: "quotation",
      routeName: "quotation",
      routeDetailName: "quotation.detail",
      importDialog: false,
      status: "all",
      statusList: [],
      quotationCategoryList: [],
      customThead: [],
      moreActions: [
        {
          title: "Import Quotation(s)",
          action: "import_items",
          divider: true,
          icon: "mdi-database-import",
        },
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      bulkActions: [
        {
          title: "Mark as Draft",
          icon: "mdi-check-all",
          action: "draft",
        },
        {
          title: "Mark as Accepted",
          icon: "mdi-check-all",
          action: "accepted",
        },
        {
          title: "Mark as Rejected",
          icon: "mdi-check-all",
          action: "rejected",
        },
        {
          title: "Mark as Pending",
          icon: "mdi-email-receive",
          action: "pending",
        },
        {
          title: "Mark as Cancelled",
          icon: "mdi-check-all",
          action: "cancelled",
        },
        {
          title: "Mark as Closed",
          icon: "mdi-check-all",
          action: "closed",
        },
      ],
      clearCustomerFiltersFlag: false,
    };
  },
  components: {
    CustomerListingFilter,
    PageTips,
    draggable,
    EntityDialog,
    PageHeaderCount,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    CustomerDialog,
    CustomerPropertyDialog,
    CustomerPersonDialog,
    Datepicker,
    ImportTemplate,
    DateRangePicker,
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param;
        } else {
          this.listingSearch["dates"] = [];
        }
      },
    },
    /*  searchDialog: {
      deep: true,
      immediate: true,
      handler(param) {
        if (!param) {
          this.customer_list = [];
          this.getCustomerList();
        }
      },
    }, */
  },
  methods: {
    openFilterDialog() {
      this.customer_list = [];
      this.getCustomerList();
      this.get_attributes();
      this.getQuotationCategories();
      this.searchDialog = true;
    },
    removeFilters() {
      SearchEventBus.$emit("clear-search", true);
    },
    getValidityDate(data) {
      if (data.added_at) {
        let date = moment(data.added_at, "YYYY-MM-DD").format("YYYY-MM-DD");
        let validity = moment(date, "YYYY-MM-DD")
          .add(data.validity_till, "days")
          .format("YYYY-MM-DD");
        return this.formatDate(validity);
      }
    },
    getColorType(data) {
      if (data == 1) {
        return "green darken-3";
      } else if (data == 2) {
        return "orange darken-3";
      } else if (data == 3) {
        return "red darken-3";
      }
    },
    getColorText(data) {
      if (data == 1) {
        return "New";
      } else if (data == 2) {
        return "Maintenance";
      } else if (data == 3) {
        return "General";
      }
    },
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    selectCustomerDialog() {
      this.customerDialog = true;
    },
    selectCustomerPersonDialog() {
      this.customerPersonDialog = true;
    },
    selectCustomerPropertyDialog() {
      this.customerPropertyDialog = true;
    },
    resetAll() {
      this.entity = 1;
      this.customer = 0;
      this.customerPerson = 0;
      this.customerProperty = 0;
      this.closeDialog();
    },
    closeDialog() {
      this.entityDialog = false;
      this.customerDialog = false;
      this.customerPersonDialog = false;
      this.customerPropertyDialog = false;
    },
    selectEntity(param) {
      this.entity = param;
      this.closeDialog();
      this.$nextTick(() => {
        this.selectCustomerDialog();
      });
    },
    selectCustomer(param) {
      this.customer = param;
      this.closeDialog();
      this.checkQuotation();
      if (!this.customerProperty || this.customerProperty <= 0) {
        this.customerPropertyDialog = true;
      }
    },
    selectCustomerPerson(param) {
      this.customerPerson = param;
      this.closeDialog();
      this.checkQuotation();
      if (!this.customerProperty || this.customerProperty <= 0) {
        this.customerPropertyDialog = true;
      }
    },
    selectCustomerProperty(param) {
      this.customerProperty = param;
      this.closeDialog();
      this.checkQuotation();
    },

    customerRedirect(customerId) {
      this.$router.push(
        this.getDefaultRoute("customer.detail", {
          params: { id: customerId },
        })
      );
    },
    checkQuotation() {
      const _this = this;
      if (_this.customer > 0 && _this.customerProperty > 0) {
        _this.$router.push(
          _this.getDefaultRoute("quotation.create", {
            query: {
              customer: _this.customer ?? undefined,
              property: _this.customerProperty ?? undefined,
            },
          })
        );
      }
    },
    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          _this.importDialog = true;
          break;
        case "export_items":
          _this.bulkQuotationExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("quotation");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
    updateBulkAction(param) {
      const _this = this;
      switch (param) {
        case "draft":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 1,
          });
          break;
        case "accepted":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 2,
          });
          break;
        case "rejected":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 3,
          });
          break;
        case "pending":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 4,
          });
          break;
        case "sent":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 5,
          });
          break;
        case "cancelled":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 6,
          });
          break;
        case "closed":
          _this.bulkQuotationUpdate({
            quotations: _this.selectedRows,
            status: 7,
          });
          break;
      }
    },
    bulkQuotationUpdate(requestObject) {
      const _this = this;
      _this.$store
        .dispatch(PATCH, {
          url: "quotation",
          data: requestObject,
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.selectedRows = [];
          _this.getRows();
        });
    },
    bulkQuotationExport() {
      const _this = this;
      let fileName = new Date();
      _this.exportLoading = true;
      _this.$store
        .dispatch(DOWNLOAD, {
          url: "quotations/export",
        })
        .then(({ data }) => {
          saveAs(data, "quotations-export-" + fileName.getTime() + ".xlsx");
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.exportLoading = false;
        });
    },
    get_attributes() {
      this.dataLoading = true;
      this.$store
        .dispatch(GET, {
          url: "get-sales-representative",
        })
        .then((response) => {
          this.userList = ObjectPath.get(response, "data.sales_users", []);
        })
        .catch((error) => {
          this.logError(error);
          this.dataLoading = false;
          this.userList = [];
          this.customer_list = [];
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    getCustomerList() {
      this.customer_loading = true;
      this.$store
        .dispatch(QUERY, {
          url: "filter-customer",
          data: { search: this.customer_search },
        })
        .then(({ data }) => {
          this.customer_list = data;
          this.customer_loading = false;
        })
        .catch((error) => {
          console.log("error");
          this.customer_list = [];
          this.logError(error);
        })
        .finally(() => {
          /* this.customer_list = []; */
          this.customer_loading = false;
        });
    },
    getQuotationCategories() {
      return this.$store
        .dispatch(QUERY, {
          url: "setting/quotation-category",
        })
        .then((response) => {
          console.log("Quotation Categories Response:", response);

          this.quotationCategoryList = ObjectPath.get(response, "data", []);
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    updateListingSearch(updatedSearch) {
      this.listingSearch = { ...this.listingSearch, ...updatedSearch };
    },

    filterRows() {
      const query = { ...this.$route.query, ...this.listingSearch };
      this.$router.push({ query }).then(() => {
        this.closeSearchDialog();
        this.getRows();
      });
    },
    clearCustomerFilters() {
      this.clearCustomerFiltersFlag = true;
      this.listingSearch = {
        ...this.listingSearch,
        customer: null,
        billing: null,
        property: null,
      };
      const query = { ...this.$route.query };
      delete query.customer;
      delete query.billing;
      delete query.property;
      this.$router.push({ query }).then(() => {
        this.getRows();
        this.$nextTick(() => {
          this.clearCustomerFiltersFlag = false;
        });
      });
    },
  },
  mounted() {
    this.resetAll();
    this.get_attributes();
    this.getQuotationCategories();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Quotation",
      },
    ]);
    this.userDetails = JwtService.currentUser();
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);
    _this.status = _this.$route.query.status || _this.status;
    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
